/**
 * 🔒 A refusal a shared rule raises (decision 2861): the person asked for
 * something the rule does not allow, and the message says what. The API's
 * refusal filter answers any instance 400 with its message as a sentence, by
 * `instanceof`, so a shared refusal answers in words without its class name
 * being typed into a list. 💰 Until 2026-10-10 a refusal answered 400 only if
 * its name was on the filter's list, and a customer statement asked for with
 * its end before its start answered a server error (T2098).
 */
export class RefusalError extends Error {}
